import { render, staticRenderFns } from "./splashScreen.vue?vue&type=template&id=c179c09c&scoped=true&"
var script = {}
import style0 from "./splashScreen.vue?vue&type=style&index=0&id=c179c09c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c179c09c",
  null
  
)

export default component.exports